"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = _interopRequireDefault(require("../config"));

var _shared = require("@exc/shared");

var _Messenger = require("../Messenger");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const userProfile = {
  setButtons: buttons => {
    let customButtons = _config.default.get('customButtons') || []; // Reset customButtons

    if (!buttons || buttons.length === 0) {
      customButtons = customButtons.filter(button => button.scope !== 'userProfile');

      _config.default.set({
        customButtons
      });

      _Messenger.messenger.setCallback(_shared.Events.CUSTOM_PROFILE_BUTTON_CLICK, null);

      return;
    } // Add buttons


    let callbacks = {};
    buttons.forEach(({
      callback,
      id,
      label
    }) => {
      customButtons.unshift({
        id,
        label,
        scope: 'userProfile'
      });
      callbacks[id] = callback;
    });

    _config.default.set({
      customButtons
    });

    _Messenger.messenger.setCallback(_shared.Events.CUSTOM_PROFILE_BUTTON_CLICK, callbacks);
  }
};
var _default = userProfile;
exports.default = _default;